module.exports = __webpack_public_path__ + "static/extend-image-ed67fb1a7c380009d89ea80ae6c45f34.png";